// extracted by mini-css-extract-plugin
export default {"wrapper":"oha-z","play":"pha-z"};